
                import { Component } from "/app/packages/sintra/lib/index.js";
                import { createDecoratorsInclude } from "/app/packages/sintra/lib/view_file_importers/js.js";
                import { decorators } from "/app/packages/blognami.com/lib/views/main/_demo_banner.js";
                const hash = "iuurlLV8OK";
                Component.include(createDecoratorsInclude(hash, decorators));
            